module.exports = __webpack_public_path__ + "h5/img/b6.49689466.jpeg";